import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";
import "regenerator-runtime/runtime";

class VirtualUserService {
    updateCurrentUser(user,) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "virtualusers/update/contact", user, {
                headers: {
                    'Use-Virtual-Session': true
                },
                json: true
            });
    }

    verifyUserEmail(user) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "auth/email/SendVerificationEmail", user, {
                headers: {
                    'Use-Virtual-Session': true
                },
                json: true
            });
    }

    clearVirtualUserTickets(request, callback) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "auth/email/clearVirtualUserTickets", request, {
                headers: {
                    'Use-Virtual-Session': true
                },
                json: true
            });
    }

    getVirtualUsersByOrgId(request) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + 'virtualusers/contact', request, {
            headers: {
                'Use-Virtual-Session': true
            },
            json: true
        });
    }

    async checkExternalIdsUniqueness (request) {
        return await axios
            .post(UrlHelper.getIdentifiApiUrl() + "virtualusers/externalIds/uniqueness", request, {
                headers: {
                    'Use-Virtual-Session': true
                },
                json: true
            });
    }

    async updateExternalIds (request) {
        return await axios
            .post(UrlHelper.getIdentifiApiUrl() + "virtualusers/update/externalIds", request, {
                headers: {
                    'Use-Virtual-Session': true
                },
                json: true
            });
    }

    async getNabpRoles () {
        return await axios
            .get(UrlHelper.getIdentifiApiUrl() + "nabpRoles", {
                headers: {
                    'Use-Virtual-Session': true
                }
            });
    }
}

export default new VirtualUserService();
